App.filter('dateFormatter', function () {
    return function (miliSec) {
        miliSec = miliSec || '';
        if (miliSec) {
            var time = new Date(miliSec);

            var day = time.getUTCDate();
            if (day < 10) {
            	day = '0' + day;
            }
            var month = time.getUTCMonth() + 1;
            if (month < 10) {
            	month = '0' + month;
            }
            var year = time.getUTCFullYear();

            var all = day + '-' + month + '-' + year;
        }
        return all;
    };
})
